import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthActions } from "src/app/modules/auth/ngrx/auth.actions.types";
import { AppState } from "src/app/ngrx/root.reducer";
import { AuthService } from "../../modules/auth/shared/services/auth.service";
import { LogService } from "src/app/shared/services/log.service";

@Component({
  selector: "rs-home-component",
  template: ""
})
export class HomeComponent implements OnInit {
  private readonly logService = inject(LogService);
  private readonly authService = inject(AuthService);
  private readonly store = inject(Store<AppState>);
  private readonly router = inject(Router);

  /**
   * Completes the sign-in that Keycloak redirected here, then opens `/esim`.
   *
   * oidc-client-ts frames this redirect_uri for silent sign-in / silent renew when a tab's settings
   * name no silent_redirect_uri. When framed, this hands the response back to the parent via
   * signinSilentCallback() (the parent does the token exchange). Running completeLogin() there would
   * race the parent for the single-use code, and the parent's signinSilent() would wait out its timeout.
   */
  ngOnInit() {
    if (window.self !== window.top) {
      void this.authService.completeSilentLogin().catch((err) => this.logService.log("[Home] Unable to silently login to webapp", err));
      return;
    }

    this.authService
      .completeLogin()
      .then(async (authData) => {
        this.store.dispatch(AuthActions.Login(authData));
        await this.router.navigate(["/esim"]);
      })
      .catch((response) => {
        if (response.message === "No state in response") {
          // Regular logout, no active session
          this.store.dispatch(AuthActions.Logout());
        }
      });
  }
}
